import { InputAdornmentProps } from '@material-ui/core';
import { AutocompleteProps } from '@material-ui/lab/Autocomplete';
import { FBAutocompleteAsyncState, FBAutocompleteProps } from '..';
import { ChangeRequestStatus } from '../../../state/ducks/changeRequest/types';
import { DocumentRevisionStatus } from '../../../state/ducks/documentRevisions/types';

export type FBAutocompleteAsyncProps =
& FBAutocompleteProps
& Pick<Partial<AutocompleteProps>, 'renderInput' | 'loading' | 'defaultValue' | 'renderTags'>
& {
  autocompleteAsyncState?: FBAutocompleteAsyncState
  selectedOptions?: string[]
  shouldReloadOnInit?: boolean
  additionalData?: any[] // TODO: make autocomplete async generic type by data
  forceNewRender?: boolean
  docTypeIds?: string[]
  documentStatuses?: DocumentRevisionStatus[]
  changeRequestStatuses?: ChangeRequestStatus[]
  /**
   * @cfg {Record} Additional url params.
   */
  urlValues?: Record<string, any>
  withoutPrefixRoot?: boolean
  withoutLabelKey?: boolean
};

export interface FBAutocompleteAsyncConfig {
  id: string
  label: string
  labelKey: string
  valueKey?: string
  root?: string
  labelPrefixRoot?: string
  includeRevision?: string
  publicApi?: boolean
  /**
   * @cfg {Bool} If true show the option in editor config.
   */
  hidden?: boolean
}

export enum FBAutocompleteAsyncOption {
  activeDocumentRevisions = '1',
  changeRequests = '2',
  availableApprovers = '3',
  documentTypes = '4',
  suppliers = '5',
  TLList = '6',
  CSLList = '7',
  companyAddresses = '8',
  GLCodes = '9',
  groups = '10',
  parts = '11',
  POList = '12',
  employees = '13',
  officialGroups = '14',
  WOParts = '15',
  DRAFTdocumentRevisions = '16',
  approvalRoles = '17',
  documentRevisions = '18',
  materials = '19',
  equipment = '20',
  availableParts = '21',
  partDocumentTypes = '22',
  preventativeMaintenaceForms = '23',
  lots = '24',
  availablePartDocuments = '25',
  supplierDocumentTypes = '26',
  ebLots = '27',
  seed = '28',
  mpiDocuments = '29',
  unitMeasures = '30',
  docRevByDoc = '31',
  docParts = '32',
  releasedEquipment = '33',
  releasedFormDocuments = '34',
  outputDocumentTypes = '35',
  trainingDocuments = '36',
  releasedParts = '42',
  companyLocations = '43',
  lotBuilds = '44',
  records = '45',
  equipmentLocations = '46',
  shippingInformation = '47',
  buildType = '48',
  equipmentSpecifications = '49',
  documentsEligibleForGroupTrainee = '51',
  allDocuments = '52',
  LHRT = '53',
  LHR = '54',
  LHRSerial = '55',
}

export interface FBAutocompleteAsyncConstructor {
  optionId?: string
  urlValues?: Record<string, any>
  docTypeIds?: string[]
  documentStatuses?: DocumentRevisionStatus[]
  changeRequestStatuses?: ChangeRequestStatus[]
  documentStatus?: string
  includePrevReleaseDoc?: boolean
}

export interface OptionDocument {
  id: string
  docId: string
  documentRevisions?: OptionDocumentRevision[]
}
export interface OptionDocumentRevision {
  id: string
  version: number
  status: DocumentRevisionStatus
  document?: OptionDocument
}

export type AutocompleteOption = OptionDocument | OptionDocumentRevision;
type AutocompleteValue = AutocompleteOption | AutocompleteOption[];
export interface BuildAutocompleteConfigProps {
  optionId?: string
  getOptionLabel: (value: AutocompleteOption, documentStatuses?: DocumentRevisionStatus[]) => string
  documentStatuses?: DocumentRevisionStatus[]
  changeRequestStatuses?: ChangeRequestStatus[]
}

type GetTagLabel = (value: AutocompleteOption, documentStatuses?: DocumentRevisionStatus[]) => React.ReactNode;
type RenderAdornment = (value: AutocompleteValue, documentStatuses?: DocumentRevisionStatus[]) => React.ReactNode;
interface AutocompleteConfig {
  getTagLabel?: GetTagLabel
  renderEndAdornment?: RenderAdornment
  renderStartAdornment?: RenderAdornment
}

export type BuildAutocompleteConfig = (props: BuildAutocompleteConfigProps) => AutocompleteConfig;

export interface AutocompleteLinkTagProps { to: string }

export interface AutocompleteAdornmentTagProps extends AutocompleteLinkTagProps {
  position?: InputAdornmentProps['position']
}

export interface FBAutocompleteAsyncSchemaItem {
  documentStatuses?: DocumentRevisionStatus[]
  changeRequestStatuses?: ChangeRequestStatus[]
}
